import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { config } from '../config';
import Header from '../components/Header';
import Footer from '../components/Footer';

const apiUrl = config.apiUrl;

const LegalPage = () => {
  const { slug } = useParams();
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLegalPage = async () => {
      try {
        const response = await axios.get(`${apiUrl}/legalpages/${slug}`);
        setLegalContent(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching legal page:", err);
        setError("Failed to load legal page. Please try again later.");
        setLoading(false);
      }
    };
    fetchLegalPage();
  }, [slug]);

  if (loading) {
    return  <div className="flex justify-center items-center h-64">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
  }

  if (!legalContent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
          <p className="text-xl text-gray-600">Legal page not found</p>
        </div>
      </div>
    );
  }

  return (
    <>
    <Header />
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 sm:p-8 text-white">
            <h1 className="text-3xl sm:text-4xl font-bold mb-2">{legalContent.title}</h1>
            <p className="text-blue-100">Last updated: {new Date(legalContent.updatedAt).toLocaleDateString()}</p>
          </div>
          
          {/* Content Section */}
          <div className="p-6 sm:p-8">
            <div 
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: legalContent.content }} 
            />
          </div>
          
          {/* Footer Section */}
          <div className="bg-gray-50 px-6 py-4 sm:px-8 border-t border-gray-200">
            <p className="text-gray-500 text-sm">
              If you have any questions about our {legalContent.title.toLowerCase()}, please contact us.
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default LegalPage;